import React, { useState, useEffect, useRef } from 'react';
import pen from '../../assets/icons/pen.svg';
import cancel from '../../assets/icons/cancel.svg';
import back from '../../assets/icons/back.svg';
import './EditPanel.scss';
import axios from 'axios';
import ColorBox from '../ColorBox/ColorBox';
import { useAuth } from '../../contexts/AuthContext'; 
//blooming-depths-76471.herokuapp.com
const EditPanel = ({id, palette, close, load, darkTheme}) => {
    const {palette_id, palette_name, color1, color2, color3, color4, color5} = palette
    const [colors, setColors] = useState([])
    const editPalette = [];
    const titleRef = useRef()
    const { currentUser } = useAuth();

   const darkBtn = {
        background: "#222831",
        boxShadow:  "12px 12px 12px #1d222a, -12px -12px 12px #272e38"
   }
   const dark = {
       color: "orange"
   }
   const darkInput = {
        color: 'orange',
        background: "#222831",
        boxShadow: "inset 16px 16px 32px #1b1f26"
   }
    
    useEffect(()=>{
        setColors([color1, color2, color3, color4, color5])
    },[palette, color1, color2, color3, color4, color5])

    function hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
         ] : null;
      }
      
      
    const handleEdit = () => {
        const paletteToEdit = {
            palette_id,
            palette_name: titleRef.current.value,
            color1: editPalette[0],
            color2: editPalette[1],
            color3: editPalette[2],
            color4: editPalette[3],
            color5: editPalette[4],
            user_id: currentUser.uid
        }
        console.log(paletteToEdit)
        axios.put(`https://blooming-depths-76471.herokuapp.com/${currentUser.uid}/${palette_id}`, paletteToEdit)
        .then(res=>{
            console.log(res)
            load(true);
        })
    }

    function getHex(col, index){
        editPalette[index] = col;
    }

    const handleDelete = (id, user) => {
        axios.delete(`http://blooming-depths-76471.herokuapp.com/${user}/${id}`)
        .then(res => {
            console.log(res);
            load(true);
        })
    }
    
    return (
        <div className="edit">
            <div className="edit__wrapper">
                <label style={(darkTheme) ? dark : null}className="edit__label"htmlFor="title">TITLE:</label>
                <input style={(darkTheme) ? darkInput : null}ref={titleRef}type="text" className="edit__title" defaultValue={palette_name}/>
            </div>
            <div className="edit__colors">
            <div style={(darkTheme) ? darkBtn : null} onClick={()=>{close()}} className="edit__back"><img className="edit__back-img"src={back} alt=""/></div>
                {colors.map((color, i) => {
                    return (
                    <ColorBox  handleHex={getHex} key={i} index={i} edit defColour={hexToRgb(color)}/>
                    )
                })}
                <div className="edit__buttons">
                    <div style={(darkTheme) ? darkBtn : null}onClick={()=>{handleEdit()}}className="edit__pen"><img className="edit__pen-img" src={pen} alt="edit pen for button"/></div>
                    <div style={(darkTheme) ? darkBtn : null}onClick={()=>{handleDelete(palette_id, currentUser.uid)}}className="edit__cancel"><img className="edit__cancel-img"src={cancel} alt="edit red cancel circle for button"/></div>
                </div>
            </div>
        </div>
    )
}

export default EditPanel
